<template>
	<div>
		<v-container>
			<v-breadcrumbs :items="breadcrumbs">
				<template #divider>
					<v-icon>mdi-chevron-left</v-icon>
				</template>
			</v-breadcrumbs>

			<v-row>
				<v-col cols="12" class="pa-2">
					<v-data-table class="elevation-1" :headers="headers" :items="notificationTimes" hide-default-footer :items-per-page="-1">
						<template #top>
							<v-toolbar flat>
								<v-toolbar-title class="px-4">منصات النشر وأوقات الإشعارات</v-toolbar-title>
								<v-divider insert vertical></v-divider>
								<v-spacer></v-spacer>
								<v-btn class="primary" @click="prepareShowNewNotificationTime">وقت جديد</v-btn>
							</v-toolbar>
						</template>

						<template #[`item.name`]="{ item }">
							{{ item.name }}
						</template>

						<template #[`item.startTime`]="{ item }">
							<v-menu v-model="item.showFrom" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
								<template #activator="{ on }">
									<v-text-field v-model="item.startTime" hide-details readonly dense :disabled="item.loading" :loading="item.loading" v-on="on"></v-text-field>
								</template>
								<v-time-picker v-model="item.startTime" ampm-in-title use-seconds></v-time-picker>
							</v-menu>
						</template>

						<template #[`item.endTime`]="{ item }">
							<v-menu v-model="item.showTo" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
								<template #activator="{ on }">
									<v-text-field v-model="item.endTime" hide-details readonly dense :disabled="item.loading" :loading="item.loading" v-on="on"></v-text-field>
								</template>
								<v-time-picker v-model="item.endTime" ampm-in-title use-seconds></v-time-picker>
							</v-menu>
						</template>

						<template #[`item.actions`]="{ item }">
							<v-tooltip bottom>
								<template #activator="{ on }">
									<v-btn color="success" :loading="item.loading" icon @click="updatePlatform(item)" v-on="on">
										<v-icon>
											mdi-update
										</v-icon>
									</v-btn>
								</template>

								<span>تحديث</span>
							</v-tooltip>

							<v-tooltip bottom>
								<template #activator="{ on }">
									<v-btn color="error" :loading="item.loading" icon @click="deletePlatform(item)" v-on="on">
										<v-icon>
											mdi-trash-can
										</v-icon>
									</v-btn>
								</template>

								<span>حذف</span>
							</v-tooltip>
						</template>
					</v-data-table>
				</v-col>
			</v-row>
		</v-container>

		<v-dialog v-model="showAddNewNotificationTime" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>
						إضافة وقت إشعارات
					</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid1">
						<v-row dense>
							<v-col cols="12" class="pa-2">
								<v-select
									v-model="newNotificationTime.platform"
									:items="platforms"
									label="المنصة"
									hide-details
									outlined
									:rules="[rules.required]"
								></v-select>
							</v-col>

							<v-col cols="12" md="6" class="pa-2">
								<v-menu
									v-model="menu1"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="290px"
								>
									<template #activator="{ on }">
										<v-text-field
											v-model="newNotificationTime.startTime"
											outlined
											hide-details="auto"
											label="من"
											readonly
											clearable
											:rules="[rules.required]"
											v-on="on"
										></v-text-field>
									</template>
									<v-time-picker v-model="newNotificationTime.startTime" ampm-in-title use-seconds></v-time-picker>
								</v-menu>
							</v-col>

							<v-col cols="12" md="6" class="pa-2">
								<v-menu
									v-model="menu2"
									:close-on-content-click="false"
									:nudge-right="40"
									transition="scale-transition"
									offset-y
									min-width="290px"
								>
									<template #activator="{ on }">
										<v-text-field
											v-model="newNotificationTime.endTime"
											outlined
											hide-details="auto"
											label="إلى"
											readonly
											clearable
											:rules="[rules.required, rules.endTimeAfterStartTime(newNotificationTime.startTime, newNotificationTime.endTime)]"
											v-on="on"
										></v-text-field>
									</template>
									<v-time-picker v-model="newNotificationTime.endTime" ampm-in-title use-seconds></v-time-picker>
								</v-menu>
							</v-col>

							<v-col cols="12" class="text-center pa-2">
								<v-btn color="primary" :disabled="!valid1" :loading="loading" @click="addNotificationTime">
									إضافة
								</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			breadcrumbs: [
				{
					text: "لوحة التحكم",
					to: { name: "dashboard-home" }
				},
				{
					text: "الإشعارات وأوقاتها",
					disabled: true
				}
			],
			notificationTimes: [],
			headers: [
				{
					text:"المنصة",
					value:"platform"
				},
				{
					text:"من",
					value:"startTime"
				},
				{
					text:"إلى",
					value:"endTime"
				},
				{
					text:"العمليات",
					value:"actions"
				},
			],
			loading: false,
			valid1: false,
			menu1: false,
			menu2: false,
			showAddNewNotificationTime: false,
			newNotificationTime: {
				platform: null,
				startTime: "00:00:00",
				endTime: "23:59:59"
			},
			platforms: [
				"Telegram",
				"Facebook",
				"Twitter",
				"iOS",
				"Android",
				"Web",
			],
		};
	},
	mounted() {
		this.getInfo();
	},
	methods: {
		prepareShowNewNotificationTime() {
			this.newNotificationTime = {
				platform: null,
				startTime: "00:00:00",
				endTime: "23:59:59"
			}
			this.showAddNewNotificationTime = true;
		},
		addNotificationTime() {
			this.loading = true;
			const platform = this.newNotificationTime;
			
			clientNotifier
				.post("/api/notificationTimes/insert", platform)
				.then(() => {
					this.showAddNewNotificationTime = false;
					this.getInfo();
				})
				.catch((err) => {
					console.log(err)
					this.loading = false;
				});
		},
		getInfo() {
			this.notificationTimes = [];
			client
				.get("/api/system/notificationTimes")
				.then(response => {
					this.loading = false;
					this.notificationTimes = response.data.data.map(platform => {
						platform.showFrom = false;
						platform.showTo = false;
						platform.loading = false;

						return platform;
					});
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		updatePlatform(platform) {
			platform.loading = true;

			clientNotifier
				.post("/api/notificationTimes/update", platform)
				.finally(() => {
					platform.loading = false;
				});
		},
		deletePlatform(platform) {
			platform.loading = true;
			console.log("dee;te")

			clientNotifier
				.delete("/api/notificationTimes/delete/" + platform.id)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");
					const index = this.notificationTimes.findIndex(p => p.id == platform.id);
					this.notificationTimes.splice(index, 1);
				})
				.finally(() => {
					platform.loading = false;
				});
		}
	}
};
</script>